// 📁 /services/unit-options.ts
import { supabase } from "@/integrations/supabase/client";

interface UnitOption {
  id: number;
  unit_name: string;
  display_order: number;
  quantity_presets: string | null;
}

/**
 * Restituisce tutte le unità di misura (ordinate per display_order).
 */
export const loadAllUnits = async (): Promise<UnitOption[]> => {
  const { data, error } = await supabase
    .from("unit_options")
    .select("*") // oppure specifica le colonne: "id, unit_name, display_order, quantity_presets"
    .order("display_order", { ascending: true });

  if (error) {
    console.error("Errore caricando l'elenco di unità di misura:", error);
    return [];
  }

  // Casting a UnitOption[] se vuoi essere più sicuro, ma controlla di avere i campi corretti
  return (data ?? []) as UnitOption[];
};

/**
 * Carica i presets di quantità per una specifica unità di misura.
 * (funzione già esistente, la lasciamo invariata)
 */
export const loadQuantityPresets = async (unit: string): Promise<string[]> => {
  if (!unit) return [];

  const { data, error } = await supabase
    .from("unit_options")
    .select("quantity_presets")
    .eq("unit_name", unit)
    .maybeSingle();

  if (error) {
    console.error(`Errore caricando quantity_presets per unità "${unit}":`, error);
    return [];
  }

  if (!data?.quantity_presets) {
    return [];
  }

  return data.quantity_presets
    .split(",")
    .map((val: string) => val.trim())
    .filter(Boolean); // rimuove stringhe vuote
};

